import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { map, mergeMap } from 'rxjs/operators';
import { OfferService } from 'src/app/shared/services/offers/offers.service';

import * as OffersOverviewSlideActions from '../offers-overview-slide.actions';

@Injectable()
export class OffersOverviewSlideEffects {
  private readonly actions$ = inject(Actions);
  private readonly offersService = inject(OfferService);

  offerMakeMatch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OffersOverviewSlideActions.offerMakeMatch),
      mergeMap((action) =>
        this.offersService
          .makeMatch(action.offerId, action.intermediary)
          .pipe(map((response) => OffersOverviewSlideActions.offerMakeMatchSuccess({ response }))),
      ),
    ),
  );
}
